import Vue from "vue";
import Model, {ModelErrors} from "./Model";
import EventModel, { EventData } from "./EventModel";

export interface EmbeddableEventWaiverData {
  fields: Record<string, string>;
}

export interface EventWaiverData {
  id?: number;
  content: string;
  event_id: number;
  entry_ref: string;
  date_created: string;
  date_updated: string;
  fields: Record<string,string>;
  _embedded?: EmbeddableEventWaiverData;
}

export default class EventWaiverModel extends Model<EventWaiverData> {
  // fields: Record<string, string> = {};
  //
  // constructor(data?: EventWaiverData, errors?: ModelErrors) {
  //   super(data, errors);
  //
  //   if (data?._embedded?.fields) {
  //     Vue.set(this, 'fields', data._embedded.fields);
  //   }
  // }
}

export function create(data?: EventWaiverData, errors?: ModelErrors): EventWaiverModel {
  return new EventWaiverModel(data, errors);
}
